import { memo, useCallback } from 'react'

import { ControlPointDuplicate } from '@mui/icons-material'
import { MenuItem, ListItemIcon, Skeleton, Typography, Divider } from '@mui/material'
import { AvcTask } from '@nativewaves/nw-cloud-sdk/content'
import { useTranslation } from 'react-i18next'

import { MenuItemCopyId, MenuItemDelete } from '@shared/components/MaterialUIEnhancements/Menu/MenuItem'
import { RowActionsProps } from '@shared/components/Table'
import { useAvcTaskCreateMutation, useAvcTaskDeleteMutation } from 'hooks/mutations/content'

const RowActionsRaw = ({ row, onClose }: RowActionsProps<AvcTask>) => {
  const { t } = useTranslation(['common', 'domain'])

  const { mutate: createAvcTask, ...avcTaskCreateMutation } = useAvcTaskCreateMutation({ originId: row.original.id })
  const { mutate: deleteAvcTask, ...avcTaskDeleteMutation } = useAvcTaskDeleteMutation()

  const handleDuplicateAvcTask = useCallback(() => {
    createAvcTask(
      { avcTaskInsert: { ...row.original, name: `${row.original.name} (${t('duplicate')})` } },
      {
        onSuccess: () => {
          onClose()
        },
      },
    )
  }, [createAvcTask, onClose, row.original, t])

  const handleDeleteAvcTask = useCallback(() => {
    onClose()

    setTimeout(() => {
      deleteAvcTask({ taskId: row.original.id })
    }, 300)
  }, [deleteAvcTask, onClose, row.original.id])

  return (
    <>
      <MenuItem onClick={handleDuplicateAvcTask} disabled={avcTaskCreateMutation.isPending}>
        <ListItemIcon>
          <ControlPointDuplicate />
        </ListItemIcon>
        <Typography sx={{ width: '100%' }}>
          {avcTaskCreateMutation.isPending ? <Skeleton variant="text" /> : t('duplicate')}
        </Typography>
      </MenuItem>
      <MenuItemCopyId onSuccess={onClose} id={row.original.id} />
      <Divider component="li" />
      <MenuItemDelete onConfirm={handleDeleteAvcTask} isLoading={avcTaskDeleteMutation.isPending} />
    </>
  )
}

export const RowActions = memo(RowActionsRaw)
